"use client"

import { SquareSigma } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareSigmaIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareSigmaIcon = component(Icon)({ as: SquareSigma })
